import { createStore, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'
import { composeWithDevTools } from 'redux-devtools-extension'
import http from '../lib/http'
import reducer from '../reducers'

const loggerMiddleware = createLogger({
  level: 'info',
  collapsed: true
})

const params = data => {
  return Object.keys(data).map(key => `${key}=${encodeURIComponent(data[key])}`).join('; ')
}

const isServer = () => Object.prototype.toString
  .call(global.process) === '[object process]' || typeof window === 'undefined'

export default (initialState = {}) => {
  let enhancer

  const cookies = initialState.cookies && isServer() ? params(initialState.cookies) : null
  const httpRequest = http(cookies)

  if (process.env.NODE_ENV !== 'production') {
    enhancer = composeWithDevTools(
      applyMiddleware(
        thunkMiddleware.withExtraArgument({
          httpRequest
        }),
        loggerMiddleware
      )
    )
  } else {
    enhancer = compose(
      applyMiddleware(
        thunkMiddleware.withExtraArgument({
          httpRequest
        })
      )
    )
  }

  return createStore(reducer, initialState, enhancer)
}



// WEBPACK FOOTER //
// ./store/initStore.js